import { useQuery } from 'react-query'
import { getCatalogoCondicao } from '../../../../formularios/core/condicao/catalogo'
import { obterModeloPublicado } from '../../../core/_requests'

/**
 * Modelo publicado da plataforma (mesma chave da listagem de protocolos, então vem do cache) e o
 * catálogo de condições, que traduz as regras e condições de exibição para pt-BR.
 */
export const useModeloPublicado = () => {
  const modelo = useQuery(
    ['protocolos-triagem', 'modelo-publicado'],
    () => obterModeloPublicado(),
    {
      retry: false,
    }
  )
  const { data: catalogo } = useQuery(['condicao', 'catalogo'], () => getCatalogoCondicao(), {
    retry: false,
    staleTime: 60 * 60 * 1000,
  })

  return { ...modelo, catalogo }
}
